
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partner/[slug]",
      function () {
        return require("private-next-pages/partner/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/partner/[slug]"])
      });
    }
  